import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import customer from "./slices/customer";
import emailPage from "./slices/emailPage";

const rootPersistConfig = {
  key: "root",
  storage,
  keyPrefix: "redux-",
  whitelist: [],
};

const customerPersistConfig = {
  key: "customer",
  storage,
  keyPrefix: "redux-",
  whitelist: ["customer"],
};

const pagePersistConfig = {
  key: "page",
  storage,
  keyPrefix: "redux-",
  whitelist: ["page"],
};

const rootReducer = combineReducers({
  page: persistReducer(pagePersistConfig, emailPage),
  customer: persistReducer(customerPersistConfig, customer),
});

export { rootPersistConfig, rootReducer };
